// src/routes/not-found.tsx
import { createFileRoute, Link } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';

import { PlatformFooter } from '@/components/common/PlatformFooter';
import { MyndwellMark } from '@/components/ui/brand-mark';
import { adminCopy } from '@/lib/copy';

export const Route = createFileRoute('/not-found')({
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col px-6 py-12">
      <div className="flex flex-1 items-center justify-center">
        <div className="bg-surface flex max-w-md flex-col items-center gap-4 rounded-xl border border-(--color-border) p-8 text-center shadow-xs">
          <MyndwellMark size="sm" tone="ink" />

          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-neutral-100 text-neutral-400">
            <SearchX className="h-6 w-6" strokeWidth={1.5} aria-hidden="true" />
          </div>

          <div className="space-y-1">
            <h1 className="text-body-md font-medium text-neutral-900">
              {adminCopy.error.notFoundTitle}
            </h1>
            <p className="text-body-md text-neutral-500">
              That page doesn&apos;t exist or you don&apos;t have access.
            </p>
          </div>

          <Link
            to="/"
            className="text-body-md text-primary-500 hover:text-primary-400 mt-2 font-medium"
          >
            Go home
          </Link>
        </div>
      </div>
      <PlatformFooter className="mx-auto w-full max-w-md" />
    </div>
  );
}
